import { getConfig } from '@/features/environment/config';

// The one sanctioned shared→features crossing for backend hosts: environment config
// lives in features/environment (legacy placement), and every per-host instance needs
// its base URL from it. Keeping every getter here means the ESLint baseline carries
// exactly one import/no-restricted-paths suppression for it instead of one per host.
export const getInsuranceUrl = () => getConfig()?.INSURANCE_URL;
export const getOrganizationUrl = () => getConfig()?.ORGANIZATION_URL;
export const getCalendarUrl = () => getConfig()?.CALENDAR_URL;
